module.exports = __webpack_public_path__ + "static/media/entrance.0445b71a.mp3";